'use strict'

export class Ecards {
    constructor(){
        this.handleAddRecipient()
    }

    handleAddRecipient(){
		const addRecipientButton = document.getElementById('ecard-add-recipient');
        if (!addRecipientButton) {
            return;
        }

        addRecipientButton.addEventListener('click', e => {
            setTimeout(()=>{
                const lastRecipient = document.querySelector('.ecards-recipient-data:last-of-type');
                if(!lastRecipient) return

                lastRecipient.querySelectorAll('input, textarea').forEach(el => el.value = '')
            }, 100)
        })
    }
}
